import { Id } from 'src/utils/types';
import { request } from '.';

export type DiaryEntry = {
  id: number;
  fk_company_id: number;
  empresa: string | null;
  titulo: string;
  mensagem: string;
  data: string;
  numero_participantes: number | null;
};

export type DiaryFilters = {
  company_id?: Id;
  start_date?: string;
  end_date?: string;
};

export type CreateDiaryPayload = {
  company_id: string;
  titulo: string;
  mensagem: string;
  data: string;
  numero_participantes?: number | null;
};

export async function getCompanyDiary(filters: DiaryFilters = {}): Promise<DiaryEntry[]> {
  const params: Record<string, string> = {};
  if (filters.company_id) params.company_id = String(filters.company_id);
  if (filters.start_date) params.start_date = filters.start_date;
  if (filters.end_date) params.end_date = filters.end_date;

  const response = await request.get<DiaryEntry[]>('/diary', { params });
  return response.data ?? [];
}

export async function createDiaryEntry(payload: CreateDiaryPayload) {
  return await request.post<DiaryEntry>('/diary', payload);
}

export async function updateDiaryEntry(id: number, payload: Partial<CreateDiaryPayload>) {
  return await request.patch<{ id: number }>(`/diary/${id}`, payload);
}

export async function deleteDiaryEntry(id: number) {
  return await request.delete(`/diary/${id}`);
}
